export default __webpack_public_path__ + "static/media/thumbs_up.5f0d7e84.svg";